import request from '../shared/http';
import { isBillingProfileComplete } from '../constants/indiaGstStates';

class BillingProfileService {
  async fetch() {
    const { data } = await request.get('/billing/profile');
    return {
      profile: data?.profile || null,
      complete: data?.complete ?? isBillingProfileComplete(data?.profile),
    };
  }

  async save(body) {
    const { data } = await request.put('/billing/profile', body);
    return {
      profile: data?.profile || null,
      complete: data?.complete ?? isBillingProfileComplete(data?.profile),
    };
  }
}

export default new BillingProfileService();
